import { SnakeLobbyFeed } from '../SnakeMarkets';
import { MonetizationBar } from '../Monetization/MonetizationBar';
import { useAppAuth } from '@/lib/useAppAuth';
import { useFtueBlocksLobby } from '../Ftue/ftueExperiment';
import { RecommendedCarousel } from './RecommendedCarousel';
import { CategorySections } from './CategorySections';
import { ExploreCategories } from './ExploreCategories';
import { BackToTopButton } from './BackToTopButton';

/**
 * Default lobby view shown when no category is selected — the V2 design
 * (Figma 1557-50407 + 5751-141388 "Lobby V2"):
 *
 * 1. "Just for you" recommended carousel (auto-sliding rail + dots)
 * 2. Monetization bar (business banner — kept from V1, authenticated only)
 * 3. "Short Markets" snake widget (live preview + currency tabs + countdown)
 * 4. One section per category with up to two question cards + "See All"
 * 5. Explore-categories chip block
 * 6. Floating "Back to Top" pill once scrolled
 *
 * The Figma frames are mobile-only; on desktop the same flow simply widens —
 * one full-width column: hero carousel (two cards per view), full-width
 * Short Markets, then category sections as a card grid (three-up at xl).
 */
export function Trending() {
  const { isAuthenticated } = useAppAuth();
  // While the full-screen FTUE covers (or is about to cover) the lobby, hold
  // the monetization surfaces back entirely — no fetch, no FULL_POPUP
  // auto-open — until the player actually arrives (product decision; the bar
  // activates the moment the overlay drops).
  const ftueActive = useFtueBlocksLobby();

  return (
    // The HomePage feed container is 100%; the trending lineup keeps its own
    // centered cap — 760px on tablet, opening to 1300px at xl so big screens
    // don't stretch the cards edge-to-edge (the authed shell has no cap of its own).
    <div className="w-full px-3.5 md:px-0 md:max-w-[760px] xl:max-w-[1300px] mx-auto flex flex-col gap-4 md:gap-5 pb-6">
      <RecommendedCarousel />
      <MonetizationBar className="w-full" enabled={isAuthenticated && !ftueActive} />
      <SnakeLobbyFeed />
      <CategorySections />
      <ExploreCategories />
      <BackToTopButton />
    </div>
  );
}
